<template>
    <div class="mt-4" v-if="exam && (exam.instruction !== null && exam.instruction.length > 0)">
        <mark-down :message="exam.instruction"></mark-down>
    </div>
    <div class="mt-4" v-else>
        <p class="no-instruction">ไม่มีรายละเอียดข้อสอบ</p>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import MarkDown from "@/components/shared/Markdown.vue";

export default {
    components: {
        MarkDown
    },

    computed: {
        ...mapGetters("ExamBuilder", ["exam"]),
    },
};
</script>

<style lang="css" scoped>
.no-instruction {
    color: orange;
    width: 100%;
    padding: 0.75rem 1.25rem;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 0.25rem;
}
</style>
